import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  CurrencyResponse,
  CurrencyRequest,
  CurrencyRateRequest,
  ExchangeRateRequest,
  CountryResponse,
  CurrencyConversionRequest,
} from './models/currency.model';

@Injectable({
  providedIn: 'root',
})
export class CurrencyService {
  private base = `${environment.apiUrl}api`;

  constructor(private http: HttpClient) {}

  getCurrencies(): Observable<CurrencyResponse[]> {
    return this.http.get<CurrencyResponse[]>(`${this.base}/currencies`);
  }

  getCurrencyById(id: number): Observable<CurrencyResponse> {
    return this.http.get<CurrencyResponse>(`${this.base}/currencies/${id}`);
  }

  createCurrency(req: CurrencyRequest): Observable<CurrencyResponse> {
    return this.http.post<CurrencyResponse>(`${this.base}/currencies`, req);
  }

  updateCurrency(
    id: number,
    req: CurrencyRequest,
  ): Observable<CurrencyResponse> {
    return this.http.put<CurrencyResponse>(
      `${this.base}/currencies/${id}`,
      req,
    );
  }

  deleteCurrency(id: number): Observable<void> {
    return this.http.delete<void>(`${this.base}/currencies/${id}`);
  }

  updateCurrencyRate(
    id: number,
    req: CurrencyRateRequest,
  ): Observable<CurrencyResponse> {
    return this.http.put<CurrencyResponse>(
      `${this.base}/currencies/${id}/rate`,
      req,
    );
  }

  getExchangeRate(
    req: ExchangeRateRequest,
  ): Observable<CurrencyConversionRequest> {
    const body = {
      fromCurrency: req.fromCurrencyCode,
      toCurrency: req.toCurrencyCode,
      amount: req.amount,
    };
    return this.http.post<CurrencyConversionRequest>(
      `${this.base}/currency-conversion`,
      body,
    );
  }

  getCountries(): Observable<CountryResponse[]> {
    return this.http.get<CountryResponse[]>(`${this.base}/countries`);
  }
}
